<template>
  <div class="protection">
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">{{ title }}</h3>
            </header>
            <div class="p-box__body">
              <div class="p-box__info">
                <div class="c-info">
                  <div class="c-info__icon">
                    <Icon name="iconQuestion" />
                  </div>
                  <div class="c-info__content">
                    <p>
                      {{ $t('pages.CompaniesLocationStore.gmbProtection.edit.info') }}
                    </p>
                  </div>
                </div>
              </div>
              <fieldset class="p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                <ul class="c-checkbox">
                  <li class="c-checkbox__item">
                    <input
                      id="update_store_gmb_synced"
                      v-model="synced"
                      type="checkbox"
                      class="c-checkbox__input"
                      @change="onChange"
                    >
                    <label class="c-checkbox__label" for="update_store_gmb_synced">
                      {{ $t('pages.CompaniesLocationStore.gmbProtection.edit.protect') }}
                    </label>
                  </li>
                </ul>
              </fieldset>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon'

export default {
  name: 'GmbProtection',
  components: {
    Icon,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
  },
  emits: ['update:modelValue'],
  data () {
    return {
      synced: this.modelValue,
    }
  },
  methods: {
    onChange() {
      this.$emit('update:modelValue', this.synced)
    }
  }
}
</script>

<style lang="scss" scoped>

.protection {
  padding-top: 32px;
}
</style>
